import { api, handleApiCall, ApiResult } from './api';
import { HomeExpenseGroupOrderingDto } from '../types/homeExpenseOrdering';

export const getGroupOrdering = async (): Promise<HomeExpenseGroupOrderingDto[]> => {
  return handleApiCall(() => api.get<ApiResult<HomeExpenseGroupOrderingDto[]>>('/api/homeexpensegroupordering'));
};

export const upsertBulkGroupOrdering = async (items: HomeExpenseGroupOrderingDto[]): Promise<HomeExpenseGroupOrderingDto[]> => {
  return handleApiCall(() => api.put<ApiResult<HomeExpenseGroupOrderingDto[]>>('/api/homeexpensegroupordering', items));
};
